export default __webpack_public_path__ + "adb108c.png";